import './async.scss'
import { MOVE_MAIS_MARK_PATH, MOVE_MAIS_MARK_VIEWBOX } from '../assets/brand-mark.js'

export default {

  inserted(el) {
    let overlay = $(
      "<div class='async-overlay'><div class='spinner'>" +
      "<svg class='loading-draw-svg' viewBox='" + MOVE_MAIS_MARK_VIEWBOX + "' xmlns='http://www.w3.org/2000/svg'>" +
      "<path class='loading-draw-path' fill-rule='evenodd' clip-rule='evenodd' d='" + MOVE_MAIS_MARK_PATH + "'/>" +
      "</svg>" +
      "</div></div>"
    );
    $(el).append(overlay).data('overlay-div', overlay);
  },

  update(el, binding) {
    if (binding.value === binding.oldValue) return;
    let $el = $(el);
    let overlay = $el.data('overlay-div');

    $el.css('position', 'relative');
    if(binding.modifiers.opacity)
      overlay.addClass('opacity-loading');
    else
      overlay.removeClass('opacity-loading');

    overlay.width($el.width() + 20);
    overlay.height($el.height());
    overlay.show();
    binding.value
      .then(() => overlay.hide())
      .catch(() => overlay.hide());
  }
}



// WEBPACK FOOTER //
// ./src/directives/async.js